import type { ToyConfig } from '../types';

const COLLECTION_KEY = 'crane_game_collection';

export class CollectionSystem {
  private unlocked: Record<string, boolean> = {};

  constructor() {
    this.load();
  }

  private load(): void {
    const saved = localStorage.getItem(COLLECTION_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved) as string[];
        parsed.forEach((id) => {
          this.unlocked[id] = true;
        });
      } catch (err) {
        console.warn('[Collection] Failed to parse saved collection', err);
      }
    }
  }

  save(): void {
    localStorage.setItem(COLLECTION_KEY, JSON.stringify(this.getAll()));
  }

  unlock(toy: ToyConfig): boolean {
    if (this.unlocked[toy.id]) return false;
    this.unlocked[toy.id] = true;
    this.save();
    return true;
  }

  has(toyId: string): boolean {
    return !!this.unlocked[toyId];
  }

  getAll(): string[] {
    return Object.keys(this.unlocked);
  }

  count(): number {
    return Object.keys(this.unlocked).length;
  }

  reset(): void {
    this.unlocked = {};
    localStorage.removeItem(COLLECTION_KEY);
  }
}
